import type { FunctionComponent, MouseEvent, ReactNode } from "react";

import type { Props as BaseLinkProps } from "~/components/common/base-link";

import { StyledButton, StyledLinkButton, StyledOffsetContainer } from "./styles";

type BaseProps = {
  backgroundColor?: string;
  children: ReactNode;
  className?: string;
  target?: string;
};

type NormalButtonProps = BaseProps & {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  variant: "button";
};

export type LinkButtonProps = BaseProps & {
  variant: "link";
} & BaseLinkProps;

type Props = NormalButtonProps | LinkButtonProps;

export const Button: FunctionComponent<Props> = props => {
  const { backgroundColor = "#fecc17", children, className, variant } = props;
  return (
    <StyledOffsetContainer backgroundColor={backgroundColor}>
      {variant === "button" ? (
        <StyledButton className={className} {...props}>
          {children}
        </StyledButton>
      ) : (
        <StyledLinkButton className={className} {...props}>
          {children}
        </StyledLinkButton>
      )}
    </StyledOffsetContainer>
  );
};

Button.displayName = "Button";
